import React from 'react';
import styled from 'styled-components';

const OutroWrapper = styled.div`
	h4 {
		padding-bottom: 30px;
	}

	@media screen and (min-width: 650px) {
		display: flex;
		justify-content: space-between;
		margin: 5em 0 0;
	}
`;

const OutroContentLeft = styled.div`
	@media screen and (min-width: 640px) {
		margin-right: 2em;
		flex: 1;
	}
`;

const OutroContentRight = styled.div`
	flex-basis: 44%;
	margin-bottom: 3em;
	em {
		font-weight: 600;
	}
	ul li {
		font-size: 17px;
		line-height: 1.3;
		padding-bottom: 13px;
	}

	@media screen and (min-width: 640px) {
		ul li {
			font-size: 22px;
		}
	}
`;

const Outro = () => {
	return (
		<section id="outro">
			<div className="container container--md">
				<OutroWrapper>
					<OutroContentRight>
						<h4>Implementing Partners</h4>
						<ul>
							<li>
								<em>My World of Bags</em>, Onireke, Oyo
							</li>
							<li>
								<em>Cute Cut</em>, Samonda, Oyo
							</li>
							<li>
								<em>Datina Designs</em>, Sango, Oyo
							</li>
							<li>
								<em>ETC Creations</em>, Oregun, Lagos
							</li>
							<li>
								<em>Gatimo Apparel</em>, Ikeja, Lagos
							</li>
							<li>
								<em>Out of Africa</em>, Maryland, Lagos
							</li>
							<li>
								<em>Promo Print Ventures</em>, Surulere, Lagos
							</li>
						</ul>
					</OutroContentRight>
					<OutroContentLeft>
						<h4>Message from Project Director</h4>
						{/* , Femi Olayebi */}
						<p>
							We are immensely pleased to have been such a critical part of the solution during the pandemic. Over
							the past 6 months, our team has worked tirelessly to reach as many Nigerians across the country as
							possible. Every mask and face shield, every gown and scrub, every foot and head cover has been crafted
							with the highest quality of materials, the utmost care and detail, by hundreds of hands that we have
							been privileged to empower through this project.
							<br />
							<br />
							We are eternally grateful to the Mastercard Foundation for tagging us in on this COVID-19 Recovery and
							Resilience Project, and for giving us the most splendid lifeline in the pandemic - one with larger
							ripples than we could ever have imagined!
						</p>
					</OutroContentLeft>
				</OutroWrapper>
			</div>
		</section>
	);
};

export default Outro;
